import doMoveObject from './original/moveObject';
import { selectGridSize, selectSnapToGrid } from '%paysera_seat_selection/js/seatSelection/redux';

function moveObject(payload) {
    return (dispatch, getState) => {
        let snapSize = null;
        if (selectSnapToGrid(getState())) {
            snapSize = selectGridSize(getState());
        }
        dispatch(doMoveObject({ ...payload, snapSize }));
    };
}

export default moveObject;
